import { render } from "./PaymentRegistration.vue?vue&type=template&id=aff8791c"
import script from "./PaymentRegistration.vue?vue&type=script&lang=js"
export * from "./PaymentRegistration.vue?vue&type=script&lang=js"

import "./PaymentRegistration.vue?vue&type=style&index=0&id=aff8791c&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__